﻿import React, { useState, useEffect } from 'react';
import { Composition } from '../../models/composition';
import { ProductListItem } from '../../models/product-list-item';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';
import { CrudFunctions } from '../../utilities/crud-functions';

import DataGrid, {
    Column,
    Selection,
    Paging,
    HeaderFilter,
    FilterRow,
    LoadPanel,
    Toolbar,
    Item as ToolbarItem,
    SearchPanel
} from 'devextreme-react/data-grid';

import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';

export interface Props {
    onApplySelections?: (products: ProductListItem[]) => void;
    onClose?: () => void;
}

export default function ProductLookupComponent(props: Props) {
    const [filteredProducts, setFilteredProducts] =
        useState<ProductListItem[]>();

    const [selectedRowKeys, setSelectedRowKeys] =
        useState<ProductListItem[]>([]);

    const [productNameFilter, setProductNameFilter] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-grow"></div>

                <div className="pw-margin-right-05">
                    <Button id="applySelectionsButton"
                        text="Apply and Close" type="default" hint="apply selections and close dialog"
                        height='2.1rem'
                        onClick={onApplySelectionsClick} />
                </div>

                <div className="pw-margin-right-05">
                    <Button id="closeButton"
                        text="Cancel" type="default" hint="cancel dialog"
                        height='2.1rem'
                        onClick={onCancelClick} />
                </div>
            </div>

            <div className="pw-comp-row" style={{ height: "3rem" }}>
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Product Name</label>
                    <TextBox id="productNameFilter" className="textbox"
                        onValueChanged={productNameFilterValueChanged}
                        onEnterKey={findProducts}
                        showClearButton={true}
                        placeholder="product name search" value={productNameFilter ? productNameFilter : undefined} />
                </div>

                <Button id="searchButton" text="Search" icon="find" type="success"
                    className="pw-button-right-labeled-textbox"
                    hint="search"
                    height={'1.6rem'}
                    onClick={onSearch} />
            </div>

            <div className="pw-margin-top-1">
                <DataGrid key="dgd-products"
                    width="100%" height="16rem"
                    dataSource={filteredProducts ? filteredProducts : []}
                    onSelectionChanged={onFilterProductsSelectionChanged}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />

                    <Selection mode='multiple' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column dataField='partNumber' dataType='string' width='10rem' />
                    <Column dataField='productStateName' caption="Product State" dataType='string' width="8rem" />
                    <Column dataField='casNumber' dataType='string' width='8rem' />
                    <Column dataField='longName' dataType='string' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Matching Products</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>

                </DataGrid>

            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onFilterProductsSelectionChanged({selectedRowKeys: changedRowKeys, selectedRowsData }) {
        setSelectedRowKeys(changedRowKeys);
            }

    function onApplySelectionsClick() {
       if (props.onApplySelections)
            props.onApplySelections(selectedRowKeys);
                }

    function productNameFilterValueChanged(e: any) {
        setProductNameFilter(e.value);
    }

    function onCancelClick(e: any) {
        if (props.onClose)
            props.onClose();
    }

    function onSearch(e: any) {
        if (productNameFilter)
            findProducts();
    }

    async function findProducts() {
        if (productNameFilter) {
            await CrudFunctions.getData(`products/productsbysearch/${productNameFilter}`)
                .then((data) => {
                    setFilteredProducts(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Matching Products");
                });
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

